import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { WidgetDate } from "@components/PreviewWidgets/WidgetDate";
import { WidgetImage } from "@components/PreviewWidgets/WidgetImage";
import { WidgetTime } from "@components/PreviewWidgets/WidgetTime";
import { WidgetWeather } from "@components/PreviewWidgets/WidgetWeather";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`;

export const RenderInnerWidget = ({ height, width, item, index }) => {
  // console.log(" height, width, :>> ", height, width);
  return (
    <Container>
      {(() => {
        const type = _.get(item, ["type"]);
        const attribute = _.get(item, ["attribute"]);
        const id = _.get(item, ["id"]);
        switch (type) {
          case "STATIC_IMAGE":
            return <WidgetImage key={id} attribute={attribute} />;
          case "STATIC_WEATHER":
            return <WidgetWeather key={id} />;
          case "STATIC_DATE":
            return <WidgetDate key={id} />;
          case "STATIC_TIME":
            return (
              <WidgetTime key={id} attribute={attribute} isPreview={true} />
            );
          default:
            return null;
        }
      })()}
    </Container>
  );
};
